import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

const data = [
  {
    included: 'Interactive guided tenant onboard',
    notIncluded: 'Tenant Referencing',
  },
  {
    included: 'Tenant ID Verification and Right to Rent Checks',
    notIncluded: 'Purchasing of compliance certificates (Gas, EICR, EPC etc)',
  },
  {
    included: 'Automatic tenancy agreement creation',
    notIncluded: 'Inventory and Check in costs',
  },
  {
    included: 'Digital signing of contracts (eSignatures)',
    notIncluded: '',
  },
];

const FeatureTable = () => {
  return (
    <View style={styles.card}>
      <View style={styles.header}>
        <Text style={styles.headerTextLeft}>WHAT'S INCLUDED PER FLO</Text>
        <Text style={styles.headerTextRight}>REQUIRES ADDITIONAL PURCHASES</Text>
      </View>

      {data.map((item, index) => (
        <View
          key={index}
          style={[
            styles.row,
            { backgroundColor: index % 2 === 0 ? '#F8F6FF' : '#FAFAFA' }, // alternate row colors
          ]}
        >
          <View style={styles.cell}>
            <MaterialIcons name="check-circle" size={20} color="#9B59B6" />
            <Text style={styles.cellText}>{item.included}</Text>
          </View>
          <View style={styles.cell}>
            {item.notIncluded ? (
              <>
                <MaterialIcons name="cancel" size={20} color="#E74C3C" />
                <Text style={styles.cellText}>{item.notIncluded}</Text>
              </>
            ) : null}
          </View>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#fff',
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 4 },
    elevation: 4, // Android shadow
  },
  header: {
    flexDirection: 'row',
    marginBottom: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    paddingBottom: 8,
  },
  headerTextLeft: {
    flex: 1,
    fontWeight: '600',
    color: '#9B59B6',
    fontSize: 13,
  },
  headerTextRight: {
    flex: 1,
    fontWeight: '600',
    color: '#E74C3C',
    fontSize: 13,
  },
  row: {
    flexDirection: 'row',
    paddingVertical: 10,
    paddingHorizontal: 4,
    borderRadius: 8,
    marginBottom: 4,
  },
  cell: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 6,
    paddingRight: 6,
  },
  cellText: {
    flex: 1,
    fontSize: 14,
    color: '#333',
  },
});

export default FeatureTable;
